import { ApolloError, MutationTuple, useMutation } from "@apollo/client/react";
import {
  FinishContent,
  FinishContentVariables,
  UpdateContentStatus,
  UpdateContentStatusVariables,
} from "__generated__/types";
import gql from "graphql-tag";

const UPDATE_CONTENT_STATUS = gql`
  mutation UpdateContentStatus($input: UpdateContentStatusInput!) {
    updateContentStatus(input: $input) {
      status
    }
  }
`;

const FINISH_CONTENT = gql`
  mutation FinishContent($input: FinishContentInput!) {
    finishContent(input: $input) {
      success
    }
  }
`;

export function useUpdateContent(): MutationTuple<
  UpdateContentStatus,
  UpdateContentStatusVariables
> {
  return useMutation<UpdateContentStatus, UpdateContentStatusVariables>(
    UPDATE_CONTENT_STATUS,
  );
}

// TODO: We must ensure this is only called in the correct context, when looking at syllabus (and not in the library)
export function useFinishContent(): {
  error?: ApolloError;
  handleFinishContent(id: string): Promise<unknown>;
} {
  const [mutateFinishContent, { error }] = useMutation<
    FinishContent,
    FinishContentVariables
  >(FINISH_CONTENT);

  return {
    error,
    async handleFinishContent(id: string) {
      return mutateFinishContent({
        variables: {
          input: {
            contentId: id,
          },
        },
      });
    },
  };
}
